export default __webpack_public_path__ + "static/media/frame.e9a83376.gif";